import React from "react";
import { Input } from "./";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";

const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    gap: "8px",
  },
  dateWrapper: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
  },
});

export default function DateRangePicker({
  onFromChange,
  from,
  onToChange,
  to,
  label,
  disabled,
}) {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <div className={classes.dateWrapper}>
        <Input
          label="Start Time - From"
          type="datetime-local"
          value={from}
          onChange={onFromChange}
          fullWidth
          disabled={disabled}
          clearable
          enableTooltip
          toolTipContent={from ? moment(from).format("DD-MM-YYYY HH:mm") : ""}
          InputLabelProps={{
            shrink: true,
          }}
          required
        />
      </div>
      <div className={classes.dateWrapper}>
        <Input
          label="Start Time - To"
          type="datetime-local"
          value={to}
          onChange={onToChange}
          fullWidth
          disabled={disabled}
          clearable
          enableTooltip
          toolTipContent={to ? moment(to).format("DD-MM-YYYY HH:mm") : ""}
          InputLabelProps={{
            shrink: true,
          }}
          required
        />
      </div>
    </div>
  );
}
